import { Search_3_0_0 } from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

function useMerchandiseSearchEventType({
  sortWasApplied,
  filterWasApplied,
}: {
  sortWasApplied: boolean
  filterWasApplied: boolean
}): Search_3_0_0 {
  if (sortWasApplied) {
    return { type: 'sort' }
  }

  if (filterWasApplied) {
    return { type: 'filters' }
  }

  return { type: 'page_landing' }
}

export default useMerchandiseSearchEventType
